import { Box } from '@mui/material';
import { bool, object, shape, string } from 'prop-types';
import React from 'react';
import Modal from '../Modal';
import connector from './connector';

const PictureModal = ({ src = null, actions, isOpen }) => {
  if (!src && !isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={actions.pictureModal.close}>
      <Box
        component="img"
        alt="modal"
        src={src}
        sx={{
          width: '100%',
          height: '100%',
          maxWidth: '90vw',
          maxHeight: '90vh',
        }}
      />
    </Modal>
  );
};

PictureModal.propTypes = {
  src: string,
  isOpen: bool.isRequired,
  actions: shape({
    pictureModal: object.isRequired,
  }).isRequired,
};

export default connector(PictureModal);
